// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__50G2b","slider":"ToggleSwitch_slider__mgPg+","round":"ToggleSwitch_round__fyuM4"};